($ => {
  Drupal.behaviors.iframe = {
    attach(context) {
      $('.paragraph-iframe iframe').each(function () {
        if ($('object[src*="outlook.office365"]')) {
          $(this).addClass('booking-tool');
        }
      });
    }
  };
})(jQuery);
